import "./headerDate.scss";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { todayDate } from "../../utils/todayDate";
import IconButton from "../iconButton/iconButton";
import NextIcon from "../../assets/images/next.svg";
import PreIcon from "../../assets/images/pre.svg";
import TodayIcon from "../../assets/images/today.svg";
import CustomDatePicker from "../customDatePicker/customDatePicker";

export default function HeaderDate({currentDate, setCurrentDate}) {
   const handleChangeDay = (action) => {
    if (action === "nextDay") {
      setCurrentDate(prev =>
        new DateObject({
          date: prev.valueOf(),
          calendar: persian,
          locale: persian_fa,
        }).add(1, "day")
      );
    } else if (action === "prevDay") {
      setCurrentDate(prev =>
        new DateObject({
          date: prev.valueOf(),
          calendar: persian,
          locale: persian_fa,
        }).subtract(1, "day")
      );
    }
  }

  return (
    <div className="headerDate">
      <IconButton icon={PreIcon} tooltip="روز قبل" onClick={() => handleChangeDay("prevDay")} />
      <div className="date">
        <IconButton icon={TodayIcon} tooltip="امروز" onClick={() => setCurrentDate(todayDate)} />
        <CustomDatePicker type="text" date={currentDate} setDate={setCurrentDate} />
      </div>
      <IconButton icon={NextIcon} tooltip="روز بعد" onClick={() => handleChangeDay("nextDay")} />
    </div>
  );
}
